'use strict';

var nodeListCompact = nodeListCompact || {};
var $ = jQuery;

/* INIT
 ----------------------------------------------------------------------------------------------------------------------*/
nodeListCompact.init = function () {
  nodeListCompact.ellipsis();
}

/* DOM READY
 ----------------------------------------------------------------------------------------------------------------------*/
$(nodeListCompact.init);

/* FUNCTIONS
 ----------------------------------------------------------------------------------------------------------------------*/
nodeListCompact.ellipsis = function () {

  // console.log('node list compact');

  $(".node--in-list-compact .field--title a").each(function(i,v){
    var txt=$(v).text();
    if(txt.length>100){
      var shortText=txt.substring(0, 100)+
        "<span>"+
        "..."+
        "</span>";

      $(v).html(shortText );
    }
  });


};